<template>
  <div
    class="relative flex h-full w-full items-center justify-center !bg-black"
  >
    <IconLoader class="h-7 w-7 text-white" />
    <ClientOnly>
      <div
        v-if="isCookieYesCompleted"
        class="absolute left-0 top-0 h-full w-full"
      >
        <iframe
          v-if="isCookieYesConsent"
          class="absolute left-0 top-0 h-full w-full"
          :src="src"
          :title="title"
        />
        <div
          v-else
          class="element_accept absolute left-0 top-0 flex h-full w-full items-center justify-center p-4"
          :class="
            imageUrl &&
            'before:contents-[\'\'] bg-cover bg-center bg-no-repeat before:absolute before:left-0 before:top-0 before:h-full before:w-full before:bg-black/60'
          "
          :style="imageUrl && { backgroundImage: `url(${imageUrl})` }"
        >
          <div class="relative text-center">
            <button
              class="element_accept-button mb-2 inline-block w-[180px] cursor-pointer truncate rounded border border-solid px-2 py-[0.375rem] text-center text-base leading-6 hover:underline active:underline tablet:py-[0.1875rem]"
              :title="t('cookie-yes.accept-button')"
              @click="handleAccept"
            >
              {{ t('cookie-yes.accept-button') }}
            </button>
            <p class="text-white">
              {{ t('cookie-yes.description.first-part') }}
              <TheNuxtLink
                :to="privacyPolicyUrl"
                :title="t('cookie-yes.policy')"
                class="element_policy-link"
              >
                {{ t('cookie-yes.policy') }}
              </TheNuxtLink>
              {{ t('cookie-yes.description.second-part') }}
            </p>
          </div>
        </div>
      </div>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();

  interface IProps {
    src: string;
    title?: string;
    imageUrl?: string;
  }

  withDefaults(defineProps<IProps>(), {
    src: '',
    title: '',
    imageUrl: '',
  });

  const cookieYesStore = useCookieYesStore();
  const { privacyPolicyUrl } = useWebsiteUrl();

  const { isCookieYesConsent, isCookieYesCompleted } =
    storeToRefs(cookieYesStore);

  const handleAccept = (): void => {
    cookieYesStore.CONSET_COOKIE_YES();
  };
</script>

<style lang="scss" scoped>
  /**
   * * NOTE: 因為 iframe 會用在 materials 頁面裡，這裡的 CSS 樣式會被官網的 CSS 樣式覆蓋掉
   * * 所以這裡的 CSS (尤其是顏色) 不能用 Tailwind CSS 來做，必須自己寫。
   * * 如果 TheButton 的樣式有改變，這裡的樣式也要跟著改變。
   */

  .element_accept {
    background-color: #323233;
  }

  .element_accept-button {
    border-color: #006eff;
    background-color: #ffffff;
    color: #006eff;

    &:hover {
      border-color: #006eff;
      background-color: #006eff;
      color: #ffffff;
    }

    &:active {
      border-color: #004eb6;
      background-color: #004eb6;
      color: #ffffff;
    }
  }

  .element_policy-link {
    color: #ffffff !important;
    text-decoration: underline !important;
  }
</style>
